import React, { useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Select, Checkbox, Row, Col } from "antd";
import { useGetProjectHotels } from "../../../hooks/project.hooks";
import { formItemLayout } from "../../../utils/UI";

const { Option } = Select;

const selectAllLayout = {
  sm: { offset: 8 },
  md: { offset: 8 },
  lg: { offset: 6 },
};

const HotelDropdown = (props) => {
  const { value, onChange, projectId, multiple } = props;

  const { data: projectHotels, isLoading } = useGetProjectHotels(projectId, {
    enabled: !!projectId,
  });

  const selectAll = useMemo(
    () =>
      Array.isArray(value) &&
      value.length > 0 &&
      value.length === projectHotels.length,
    [value],
  );

  useEffect(() => {
    onChange(undefined);
  }, [projectId]);

  return (
    <>
      {!!multiple && projectHotels?.length > 0 ? (
        <Row>
          <Col {...selectAllLayout}>
            <Checkbox
              checked={selectAll}
              onChange={(e) => {
                onChange(
                  e.target.checked
                    ? projectHotels.map((hotel) => hotel._id)
                    : [],
                );
              }}
              style={{ lineHeight: "15px", marginBottom: "10px" }}
            >
              Select all hotels in the group
            </Checkbox>
          </Col>
        </Row>
      ) : null}
      <Form.Item label="Hotel Name" {...formItemLayout}>
        <Select
          placeholder="Please Select Hotel(s)"
          {...(multiple ? { mode: "multiple" } : {})}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          value={value}
          onChange={onChange}
          loading={isLoading}
        >
          {Array.isArray(projectHotels)
            ? projectHotels.map((hotel) => {
                return (
                  <Option key={hotel._id} value={hotel._id}>
                    {`${hotel.hotel_code} - ${hotel.hotel_name}`}
                  </Option>
                );
              })
            : null}
        </Select>
      </Form.Item>
    </>
  );
};

HotelDropdown.defaultProps = {
  multiple: true,
  projectId: undefined,
  value: undefined,
};

HotelDropdown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  projectId: PropTypes.string,
  multiple: PropTypes.bool,
};

export default HotelDropdown;
